export default __webpack_public_path__ + "static/media/notif.ae93f955.mp3";